import { WlTransactionOperation } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export { WlTransactionOperation };

export const wlTransactionOperationDictionary = createSimpleDictionary([
    { id: WlTransactionOperation.Debit, name: 'dictionaries.wlTransactionOperation.debit' },
    { id: WlTransactionOperation.Credit, name: 'dictionaries.wlTransactionOperation.credit' },
    { id: WlTransactionOperation.Info, name: 'dictionaries.wlTransactionOperation.info' },
]);
